export default __webpack_public_path__ + "static/media/8.9f96e544.jpg";